module.exports = __webpack_public_path__ + "img/logo2.6dee5062.png";